/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {FCRModelPost} from '../bioplanModels';
// @ts-ignore
import type {FCRModelPut} from '../bioplanModels';
// @ts-ignore
import type {FCRModelResponse} from '../bioplanModels';
// @ts-ignore
import type {FCRModelRowPost} from '../bioplanModels';
// @ts-ignore
import type {FCRModelRowPut} from '../bioplanModels';
// @ts-ignore
import type {FCRModelRowResponse} from '../bioplanModels';
/**
 * ModellingFeedConversionRatioModelsApi - axios parameter creator
 * @export
 */
export const ModellingFeedConversionRatioModelsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all feed conversion ratio models for plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('feedConversionRatioModelsGet', 'planId', planId);
      const localVarPath = `/feedConversionRatioModels/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete feed conversion ratio model by its identifier
     * @param {string} modelId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdDelete: async (
      modelId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdDelete', 'modelId', modelId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdDelete', 'planId', planId);
      const localVarPath = `/feedConversionRatioModels/{modelId}`.replace(
        `{${'modelId'}}`,
        encodeURIComponent(String(modelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get feed conversion ratio model by its identifier
     * @param {string} modelId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdGet: async (
      modelId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdGet', 'modelId', modelId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdGet', 'planId', planId);
      const localVarPath = `/feedConversionRatioModels/{modelId}`.replace(
        `{${'modelId'}}`,
        encodeURIComponent(String(modelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update feed conversion ratio model
     * @param {string} modelId
     * @param {FCRModelPut} fCRModelPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdPut: async (
      modelId: string,
      fCRModelPut: FCRModelPut,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdPut', 'modelId', modelId);
      // verify required parameter 'fCRModelPut' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdPut', 'fCRModelPut', fCRModelPut);
      const localVarPath = `/feedConversionRatioModels/{modelId}`.replace(
        `{${'modelId'}}`,
        encodeURIComponent(String(modelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(fCRModelPut, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete row for a given feed conversion ratio model
     * @param {string} modelId
     * @param {string} id
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdRowsDelete: async (
      modelId: string,
      id: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdRowsDelete', 'modelId', modelId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdRowsDelete', 'id', id);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdRowsDelete', 'planId', planId);
      const localVarPath = `/feedConversionRatioModels/{modelId}/rows/`.replace(
        `{${'modelId'}}`,
        encodeURIComponent(String(modelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all rows for a given feed conversion ratio model
     * @param {string} modelId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdRowsGet: async (
      modelId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdRowsGet', 'modelId', modelId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdRowsGet', 'planId', planId);
      const localVarPath = `/feedConversionRatioModels/{modelId}/rows/`.replace(
        `{${'modelId'}}`,
        encodeURIComponent(String(modelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Add row for a given feed conversion ratio model
     * @param {string} modelId
     * @param {FCRModelRowPost} fCRModelRowPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdRowsPost: async (
      modelId: string,
      fCRModelRowPost: FCRModelRowPost,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdRowsPost', 'modelId', modelId);
      // verify required parameter 'fCRModelRowPost' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdRowsPost', 'fCRModelRowPost', fCRModelRowPost);
      const localVarPath = `/feedConversionRatioModels/{modelId}/rows/`.replace(
        `{${'modelId'}}`,
        encodeURIComponent(String(modelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(fCRModelRowPost, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update row for a given feed conversion ratio model
     * @param {string} modelId
     * @param {FCRModelRowPut} fCRModelRowPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdRowsPut: async (
      modelId: string,
      fCRModelRowPut: FCRModelRowPut,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdRowsPut', 'modelId', modelId);
      // verify required parameter 'fCRModelRowPut' is not null or undefined
      assertParamExists('feedConversionRatioModelsModelIdRowsPut', 'fCRModelRowPut', fCRModelRowPut);
      const localVarPath = `/feedConversionRatioModels/{modelId}/rows/`.replace(
        `{${'modelId'}}`,
        encodeURIComponent(String(modelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(fCRModelRowPut, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create feed conversion ratio model for plan
     * @param {FCRModelPost} fCRModelPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsPost: async (
      fCRModelPost: FCRModelPost,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fCRModelPost' is not null or undefined
      assertParamExists('feedConversionRatioModelsPost', 'fCRModelPost', fCRModelPost);
      const localVarPath = `/feedConversionRatioModels/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(fCRModelPost, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ModellingFeedConversionRatioModelsApi - functional programming interface
 * @export
 */
export const ModellingFeedConversionRatioModelsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ModellingFeedConversionRatioModelsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get all feed conversion ratio models for plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async feedConversionRatioModelsGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FCRModelResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.feedConversionRatioModelsGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingFeedConversionRatioModelsApi.feedConversionRatioModelsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete feed conversion ratio model by its identifier
     * @param {string} modelId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async feedConversionRatioModelsModelIdDelete(
      modelId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.feedConversionRatioModelsModelIdDelete(
        modelId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingFeedConversionRatioModelsApi.feedConversionRatioModelsModelIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get feed conversion ratio model by its identifier
     * @param {string} modelId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async feedConversionRatioModelsModelIdGet(
      modelId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FCRModelResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.feedConversionRatioModelsModelIdGet(
        modelId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingFeedConversionRatioModelsApi.feedConversionRatioModelsModelIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update feed conversion ratio model
     * @param {string} modelId
     * @param {FCRModelPut} fCRModelPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async feedConversionRatioModelsModelIdPut(
      modelId: string,
      fCRModelPut: FCRModelPut,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FCRModelResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.feedConversionRatioModelsModelIdPut(
        modelId,
        fCRModelPut,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingFeedConversionRatioModelsApi.feedConversionRatioModelsModelIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete row for a given feed conversion ratio model
     * @param {string} modelId
     * @param {string} id
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async feedConversionRatioModelsModelIdRowsDelete(
      modelId: string,
      id: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.feedConversionRatioModelsModelIdRowsDelete(
        modelId,
        id,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingFeedConversionRatioModelsApi.feedConversionRatioModelsModelIdRowsDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all rows for a given feed conversion ratio model
     * @param {string} modelId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async feedConversionRatioModelsModelIdRowsGet(
      modelId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FCRModelRowResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.feedConversionRatioModelsModelIdRowsGet(
        modelId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingFeedConversionRatioModelsApi.feedConversionRatioModelsModelIdRowsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Add row for a given feed conversion ratio model
     * @param {string} modelId
     * @param {FCRModelRowPost} fCRModelRowPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async feedConversionRatioModelsModelIdRowsPost(
      modelId: string,
      fCRModelRowPost: FCRModelRowPost,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FCRModelResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.feedConversionRatioModelsModelIdRowsPost(
        modelId,
        fCRModelRowPost,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingFeedConversionRatioModelsApi.feedConversionRatioModelsModelIdRowsPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update row for a given feed conversion ratio model
     * @param {string} modelId
     * @param {FCRModelRowPut} fCRModelRowPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async feedConversionRatioModelsModelIdRowsPut(
      modelId: string,
      fCRModelRowPut: FCRModelRowPut,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FCRModelResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.feedConversionRatioModelsModelIdRowsPut(
        modelId,
        fCRModelRowPut,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingFeedConversionRatioModelsApi.feedConversionRatioModelsModelIdRowsPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create feed conversion ratio model for plan
     * @param {FCRModelPost} fCRModelPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async feedConversionRatioModelsPost(
      fCRModelPost: FCRModelPost,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FCRModelResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.feedConversionRatioModelsPost(fCRModelPost, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingFeedConversionRatioModelsApi.feedConversionRatioModelsPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ModellingFeedConversionRatioModelsApi - factory interface
 * @export
 */
export const ModellingFeedConversionRatioModelsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ModellingFeedConversionRatioModelsApiFp(configuration);
  return {
    /**
     *
     * @summary Get all feed conversion ratio models for plan
     * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsGet(
      requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<FCRModelResponse>> {
      return localVarFp
        .feedConversionRatioModelsGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete feed conversion ratio model by its identifier
     * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdDelete(
      requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .feedConversionRatioModelsModelIdDelete(requestParameters.modelId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get feed conversion ratio model by its identifier
     * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdGet(
      requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FCRModelResponse> {
      return localVarFp
        .feedConversionRatioModelsModelIdGet(requestParameters.modelId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update feed conversion ratio model
     * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdPut(
      requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FCRModelResponse> {
      return localVarFp
        .feedConversionRatioModelsModelIdPut(requestParameters.modelId, requestParameters.fCRModelPut, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete row for a given feed conversion ratio model
     * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdRowsDelete(
      requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .feedConversionRatioModelsModelIdRowsDelete(
          requestParameters.modelId,
          requestParameters.id,
          requestParameters.planId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all rows for a given feed conversion ratio model
     * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdRowsGet(
      requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<FCRModelRowResponse>> {
      return localVarFp
        .feedConversionRatioModelsModelIdRowsGet(requestParameters.modelId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Add row for a given feed conversion ratio model
     * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdRowsPost(
      requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FCRModelResponse> {
      return localVarFp
        .feedConversionRatioModelsModelIdRowsPost(requestParameters.modelId, requestParameters.fCRModelRowPost, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update row for a given feed conversion ratio model
     * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsModelIdRowsPut(
      requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FCRModelResponse> {
      return localVarFp
        .feedConversionRatioModelsModelIdRowsPut(requestParameters.modelId, requestParameters.fCRModelRowPut, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create feed conversion ratio model for plan
     * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedConversionRatioModelsPost(
      requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FCRModelResponse> {
      return localVarFp
        .feedConversionRatioModelsPost(requestParameters.fCRModelPost, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for feedConversionRatioModelsGet operation in ModellingFeedConversionRatioModelsApi.
 * @export
 * @interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsGetRequest
 */
export interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsGetRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsGet
   */
  readonly planId: string;
}

/**
 * Request parameters for feedConversionRatioModelsModelIdDelete operation in ModellingFeedConversionRatioModelsApi.
 * @export
 * @interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdDeleteRequest
 */
export interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdDelete
   */
  readonly modelId: string;

  /**
   *
   * @type {string}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdDelete
   */
  readonly planId: string;
}

/**
 * Request parameters for feedConversionRatioModelsModelIdGet operation in ModellingFeedConversionRatioModelsApi.
 * @export
 * @interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdGetRequest
 */
export interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdGet
   */
  readonly modelId: string;

  /**
   *
   * @type {string}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for feedConversionRatioModelsModelIdPut operation in ModellingFeedConversionRatioModelsApi.
 * @export
 * @interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdPutRequest
 */
export interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdPut
   */
  readonly modelId: string;

  /**
   *
   * @type {FCRModelPut}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdPut
   */
  readonly fCRModelPut: FCRModelPut;
}

/**
 * Request parameters for feedConversionRatioModelsModelIdRowsDelete operation in ModellingFeedConversionRatioModelsApi.
 * @export
 * @interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsDeleteRequest
 */
export interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsDelete
   */
  readonly modelId: string;

  /**
   *
   * @type {string}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsDelete
   */
  readonly id: string;

  /**
   *
   * @type {string}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsDelete
   */
  readonly planId: string;
}

/**
 * Request parameters for feedConversionRatioModelsModelIdRowsGet operation in ModellingFeedConversionRatioModelsApi.
 * @export
 * @interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsGetRequest
 */
export interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsGetRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsGet
   */
  readonly modelId: string;

  /**
   *
   * @type {string}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsGet
   */
  readonly planId: string;
}

/**
 * Request parameters for feedConversionRatioModelsModelIdRowsPost operation in ModellingFeedConversionRatioModelsApi.
 * @export
 * @interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPostRequest
 */
export interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPostRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPost
   */
  readonly modelId: string;

  /**
   *
   * @type {FCRModelRowPost}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPost
   */
  readonly fCRModelRowPost: FCRModelRowPost;
}

/**
 * Request parameters for feedConversionRatioModelsModelIdRowsPut operation in ModellingFeedConversionRatioModelsApi.
 * @export
 * @interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPutRequest
 */
export interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPutRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPut
   */
  readonly modelId: string;

  /**
   *
   * @type {FCRModelRowPut}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPut
   */
  readonly fCRModelRowPut: FCRModelRowPut;
}

/**
 * Request parameters for feedConversionRatioModelsPost operation in ModellingFeedConversionRatioModelsApi.
 * @export
 * @interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsPostRequest
 */
export interface ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsPostRequest {
  /**
   *
   * @type {FCRModelPost}
   * @memberof ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsPost
   */
  readonly fCRModelPost: FCRModelPost;
}

/**
 * ModellingFeedConversionRatioModelsApi - object-oriented interface
 * @export
 * @class ModellingFeedConversionRatioModelsApi
 * @extends {BaseAPI}
 */
export class ModellingFeedConversionRatioModelsApi extends BaseAPI {
  /**
   *
   * @summary Get all feed conversion ratio models for plan
   * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingFeedConversionRatioModelsApi
   */
  public feedConversionRatioModelsGet(
    requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingFeedConversionRatioModelsApiFp(this.configuration)
      .feedConversionRatioModelsGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete feed conversion ratio model by its identifier
   * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingFeedConversionRatioModelsApi
   */
  public feedConversionRatioModelsModelIdDelete(
    requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingFeedConversionRatioModelsApiFp(this.configuration)
      .feedConversionRatioModelsModelIdDelete(requestParameters.modelId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get feed conversion ratio model by its identifier
   * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingFeedConversionRatioModelsApi
   */
  public feedConversionRatioModelsModelIdGet(
    requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingFeedConversionRatioModelsApiFp(this.configuration)
      .feedConversionRatioModelsModelIdGet(requestParameters.modelId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update feed conversion ratio model
   * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingFeedConversionRatioModelsApi
   */
  public feedConversionRatioModelsModelIdPut(
    requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingFeedConversionRatioModelsApiFp(this.configuration)
      .feedConversionRatioModelsModelIdPut(requestParameters.modelId, requestParameters.fCRModelPut, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete row for a given feed conversion ratio model
   * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingFeedConversionRatioModelsApi
   */
  public feedConversionRatioModelsModelIdRowsDelete(
    requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingFeedConversionRatioModelsApiFp(this.configuration)
      .feedConversionRatioModelsModelIdRowsDelete(
        requestParameters.modelId,
        requestParameters.id,
        requestParameters.planId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all rows for a given feed conversion ratio model
   * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingFeedConversionRatioModelsApi
   */
  public feedConversionRatioModelsModelIdRowsGet(
    requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingFeedConversionRatioModelsApiFp(this.configuration)
      .feedConversionRatioModelsModelIdRowsGet(requestParameters.modelId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Add row for a given feed conversion ratio model
   * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingFeedConversionRatioModelsApi
   */
  public feedConversionRatioModelsModelIdRowsPost(
    requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingFeedConversionRatioModelsApiFp(this.configuration)
      .feedConversionRatioModelsModelIdRowsPost(requestParameters.modelId, requestParameters.fCRModelRowPost, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update row for a given feed conversion ratio model
   * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingFeedConversionRatioModelsApi
   */
  public feedConversionRatioModelsModelIdRowsPut(
    requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsModelIdRowsPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingFeedConversionRatioModelsApiFp(this.configuration)
      .feedConversionRatioModelsModelIdRowsPut(requestParameters.modelId, requestParameters.fCRModelRowPut, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create feed conversion ratio model for plan
   * @param {ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingFeedConversionRatioModelsApi
   */
  public feedConversionRatioModelsPost(
    requestParameters: ModellingFeedConversionRatioModelsApiFeedConversionRatioModelsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingFeedConversionRatioModelsApiFp(this.configuration)
      .feedConversionRatioModelsPost(requestParameters.fCRModelPost, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
